import styled, { css } from 'styled-components';
import { animated } from '@react-spring/web';

import WaveSVG from 'Public/graphics/waves/loading/wave-loading.svg';

export const Container = styled.div`
    ${({ theme }) => css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 11rem;
        height: 5rem;
        background-color: ${theme.colors.primaryContrast.hex};
        border: ${theme.commonStyles.brandPixel} solid ${theme.colors.secondary.tints[1].hex};
        border-radius: 0.5rem;
        z-index: 1001;
        box-shadow: 0.1rem 0.1rem 0.25rem rgba(0, 0, 0, 0.08),
            -0.1rem -0.1rem 0.25rem rgba(0, 0, 0, 0.08);
        position: absolute;
        left: calc(50% - (11rem / 2));
        margin-top: 3rem;
    `}
`;

export const Wave = styled(animated(WaveSVG))`
    ${({ theme }) => css`
        width: 100%;
        height: 100%;
        border-radius: 0.5rem 0.5rem 0 0;
        background: linear-gradient(
            -45deg,
            ${theme.colors.secondary.tints[1].hex},
            ${theme.colors.secondary.tints[1].hex},
            ${theme.colors.secondary.tints[1].hex},
            ${theme.colors.secondary.tints[1].hex},
            ${theme.colors.secondary.tints[1].hex},
            ${theme.colors.secondary.tints[1].hex},
            ${theme.colors.secondary.tints[1].hex},
            ${theme.colors.tertiary.hex},
            ${theme.colors.tertiary.hex},
            ${theme.colors.tertiary.hex},
            ${theme.colors.secondary.tints[1].hex},
            ${theme.colors.secondary.tints[1].hex},
            ${theme.colors.secondary.tints[1].hex},
            ${theme.colors.secondary.tints[1].hex},
            ${theme.colors.secondary.tints[1].hex},
            ${theme.colors.secondary.tints[1].hex},
            ${theme.colors.secondary.tints[1].hex}
        );
        background-size: 400% 400%;
        animation: Gradient 3s linear infinite;

        @keyframes Gradient {
            0% {
                background-position: 100% 50%;
            }
            100% {
                background-position: 0% 50%;
            }
        }
    `}
`;

export const LoadingText = styled.p`
    margin: 0.25rem 0;
    font-weight: bold;
    font-size: 1.25rem;
`;
